import httpRequest from "@/utils/api";
import type { TenantConsoleAuthContext, TenantConsoleLoginResponse } from "@/types/auth";

export const loginAPI = (loginName: string, password: string) => {
  return httpRequest.post<TenantConsoleLoginResponse>({
    url: "/tenant-console/auth/login",
    data: {
      loginName,
      password,
    },
  });
};

export const logoutAPI = () => {
  return httpRequest.post<null>({
    url: "/tenant-console/auth/logout",
  });
};

export const getMeAPI = () => {
  return httpRequest.get<TenantConsoleAuthContext>({
    url: "/tenant-console/auth/me",
  });
};
